import { format, isSameDay } from 'date-fns';
import { DateRange } from 'react-day-picker';

function getItineraryTitle(dateRange: DateRange | undefined, mobile: boolean) {
  if (dateRange && dateRange.from && dateRange.to) {
    const fromDate = dateRange.from;
    const toDate = dateRange.to;

    if (isSameDay(fromDate, toDate)) {
      return format(fromDate, 'EEE, MMMM d, yyyy');
    }

    if (mobile) {
      const startYear = format(fromDate, 'yyyy');
      const endYear = format(toDate, 'yyyy');
      if (startYear === endYear) {
        return `${format(fromDate, 'EEE, MMM d')} - ${format(toDate, 'EEE, MMM d, yyyy')}`;
      }
      return `${format(fromDate, 'EEE, MMM d, yyyy')} - ${format(toDate, 'EEE, MMM d, yyyy')}`;
    }
    // dates not shortened on desktop
    return `${format(fromDate, 'EEE, MMMM d, yyyy')} - ${format(toDate, 'EEE, MMMM d, yyyy')}`;
  }
  return 'Set your trip dates';
}

export default getItineraryTitle;
